(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Docente', Docente);

    Docente.$inject = ['$resource'];

    function Docente ($resource) {
        var resourceUrl =  'apo/clasesdocente:anio,:modelo,:nivel,:centro,:indice,:ic,:iic/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
